import { render, staticRenderFns } from "./related-manual-article.vue?vue&type=template&id=60bc14cd"
import script from "./related-manual-article.vue?vue&type=script&lang=js"
export * from "./related-manual-article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports